import { supabase } from "@/integrations/supabase/client";

/**
 * Fetches the full site config from the database and builds the
 * `site_config` payload expected by the plesk-provision edge function.
 */
export async function buildDeployPayload(siteId: string, domain: string) {
  const { data: site, error } = await supabase
    .from("websites")
    .select("name, tagline, description, logo_url, template_id, niche, primary_language, theme_config, content_config, monetization_config, ai_config, automation_config")
    .eq("id", siteId)
    .single();

  if (error) throw new Error("Could not load site configuration");

  return {
    website_id: siteId,
    domain,
    site_config: {
      site_name: site.name ?? "",
      site_description: site.description ?? "",
      site_tagline: site.tagline ?? "",
      logo_url: site.logo_url ?? "",
      template_id: site.template_id ?? "",
      niche: site.niche ?? "",
      primary_language: site.primary_language ?? "en",
      theme_config: site.theme_config ?? {},
      content_config: site.content_config ?? {},
      monetization_config: site.monetization_config ?? {},
      ai_config: site.ai_config ?? {},
      automation_config: site.automation_config ?? {},
    },
  };
}
